<div class="mydealer-section">
  <ng-container *ngIf="!state?.isError && !state?.loading; else elseTemplate">
    <div class="row">
      <div class="dealerName colsec col-lg-3 col-xl-3 col-md-12 col-sm-12" tabindex="0">
        <div class="one-mydealer-section-details-labels">
          {{ state.myDealer.firstName }} {{ state.myDealer.lastName }}
        </div>
      </div>
      <div class="colsec col-lg-3 col-xl-3 col-md-12 col-sm-12" tabindex="0">
        <div class="mydealer-section-details-labels" *ngIf="state.page !== parentPage.dashboard" (click)="contactClickOn.emit('phone-number')">
          <img class="phone" src="{{ state.myDealer.phone.icon?.iconPath }}"
            alt="{{ state.myDealer.phone.icon?.altText }}" />
          {{ state.myDealer.phone.label }}
        </div>
        <div class="mydealer-section-details-labels" *ngIf="state.page === parentPage.dashboard">
            <img class="phone" src="{{ state.myDealer.phone.icon?.iconPath }}"
              alt="{{ state.myDealer.phone.icon?.altText }}" />
          <span>{{ state.myDealer.phone.label }}</span>
        </div>
        <a class="no-underline" *ngIf="state.myDealer.phone.value !== '—'" href="tel:{{state.myDealer.phone.value}}" (click)="contactClickOn.emit('phone-number')">
          <div role="button" class="mydealer-section-details-values-phone">
            {{ state.myDealer.phone.value }}
          </div>
        </a>
        <a class="no-underline" *ngIf="state.myDealer.phone.value === '—'">
          <div class="mydealer-section-details-values-phone null-value">
            {{ state.myDealer.phone.value }}
          </div>
        </a>
      </div>
      <div class="colsec-email col-lg-3 col-xl-3 col-md-12 col-sm-12" tabindex="0">
        <div class="mydealer-section-details-labels" *ngIf="state.page !== parentPage.dashboard" (click)="contactClickOn.emit('email')">
          <img class="email" src="{{ state.myDealer.email.icon?.iconPath }}"
            alt="{{ state.myDealer.email.icon?.altText }}" />
          {{ state.myDealer.email.label }}
        </div>
        <div class="mydealer-section-details-labels" *ngIf="state.page === parentPage.dashboard">
            <img  class="email" src="{{ state.myDealer.email.icon?.iconPath }}"
            alt="{{ state.myDealer.email.icon?.altText }}" />
          <span>{{ state.myDealer.email.label }}</span>
        </div>
        <a class="no-underline" *ngIf="state.myDealer.email.value !== '—'" href="mailto:{{state.myDealer.email.value}}" (click)="contactClickOn.emit('email')">
          <div role="button"class="mydealer-section-details-values-email">
            {{ state.myDealer.email.value}}
          </div>
        </a>
        <a class="no-underline" *ngIf="state.myDealer.email.value === '—'">
          <div class="mydealer-section-details-values-email null-value">
            {{ state.myDealer.email.value}}
          </div>
        </a>
      </div>
      <div class="colsec col-lg-3 col-xl-3 col-md-12 col-sm-12" tabindex="0">
        <div class="mydealer-section-details-address-container">
          <img class="address" src="{{ state.myDealer.address.icon?.iconPath }}" alt="{{ state.myDealer.address.icon?.altText }}" />
          <div class="mydealer-section-details-labels-address">
            <div class="location-property"> {{ state.myDealer.address.label }}</div>
            <div class="mydealer-section-details-values-address" *ngIf="state.myDealer.address.value.addressLine1 || state.myDealer.address.value.addressLine2 || formatAddress(state.myDealer.address)">
              <div>{{ state.myDealer.address.value.addressLine1}}<span *ngIf="state.myDealer.address.value.addressLine1 && (state.myDealer.address.value.addressLine2 || formatAddress(state.myDealer.address))">,</span></div>
              <div> {{ state.myDealer.address.value.addressLine2}}<span *ngIf="state.myDealer.address.value.addressLine2 && formatAddress(state.myDealer.address)">,</span></div>
              <div>{{ formatAddress(state.myDealer.address)}}</div>
            </div>
            <div class="mydealer-section-details-values-address" *ngIf="!addressView">
              {{ state.myDealer.address.value.addressLine1}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  
  <ng-template #elseTemplate>
    <div class="row" *ngIf="!state?.loading">
      <div class="no-results">
        <img class="no-results-icon" src="{{state?.noResult?.iconPath}}" alt="{{state?.noResult?.altText}}" tabindex="0" loading="lazy"/>
        <div class="no-results-title" tabindex="0">{{state.noResult?.label}}</div>
        <div class="no-results-text" tabindex="0">{{state.noResult?.text}}</div>
    </div>
    </div>
  </ng-template>

  <div class="opencontactform--buttons" *ngIf="state.isButton && state.button">
    <kng-button class="opencontactform-button" [state]="state.button" (clicked)="handleClick()">
    </kng-button>
  </div>
</div>

<div  class="mydealer-section" *ngIf="state?.loading" >
  <p class="loader">
      <img  src="{{loaderState.imagePath }}" alt="loader"  loading="lazy"/>
  </p>
</div>